import React, { useEffect, useState } from "react";
import { useParams, useNavigate, NavLink } from "react-router-dom";

import MenuIcon from '@mui/icons-material/Menu';

import { Clientes } from "../../../../../pages/empresa_uno/clientes";
import { ClientesMayoristas } from "../../../../../pages/empresa_uno/ClientesMayoristas";
import { SolicitudesClientes } from "../../../../../pages/empresa_uno/solicitudesClientes";
import { Users } from "../../../../../pages/empresa_uno/users";

import check_paper from "../../../../../images/paper_check.png";
import clientes_circular from "../../../../../images/clientes_circular.png";
import clientes_hosming from "../../../../../images/clientes_hosming.png";
import usuarios from "../../../../../images/clientes_plomo.png";
import { useProveedorCompany, Error404 } from '../../../../../components';
import HojaCheckIcon from "../../../../../svg/HojaCheckIcon";
import HandsPeopleIcon from "../../../../../svg/HandsPeopleIcon";
import CirclePeopleIcon from "../../../../../svg/CirclePeopleIcon";
import GroupsIcon from '@mui/icons-material/Groups';
import { Box } from "@mui/material";

const array_subdirectorys = ["listar", "mayorista", "solicitudes", "usuarios"];

export const Cliente_EU = ({ sucursal_selected, obj_sucursal, setSelected }) => {
	const navigate = useNavigate();
	const { nit, sub_direc } = useParams();

	const { currentBranch, loadImageS } = useProveedorCompany();

	const currenRoll = currentBranch?.code ?? "none";

	const pageAllow = {
		V2D0: {
			[array_subdirectorys[0]]: {
				detail: true,
				insert: true,
				edit: true,
				deleteP: true,
				leer: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
			}
		},
		S3C1: {
			[array_subdirectorys[0]]: {
				detail: true,
				insert: true,
				edit: true,
				deleteP: true,
				leer: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
			}
		},
		A1M0: {
			[array_subdirectorys[0]]: {
				detail: true,
				insert: true,
				edit: true,
				deleteP: true,
				leer: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				edit: true,
				insert: true,
			},
			[array_subdirectorys[2]]: {
				leer: true,
				edit: true,
			}
		},
		G3R1: {
			[array_subdirectorys[0]]: {
				detail: true,
				insert: true,
				edit: true,
				deleteP: true,
				leer: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				edit: true,
				insert: true,
			},
			[array_subdirectorys[2]]: {
				leer: true,
				edit: true,
			}
		},
		S4A1: {
			[array_subdirectorys[0]]: {
				detail: true,
				insert: true,
				edit: true,
				deleteP: true,
				leer: true,
			},
			[array_subdirectorys[1]]: {
				leer: true,
				edit: true,
				insert: true,
			},
			[array_subdirectorys[2]]: {
				leer: true,
				edit: true,
			},
			[array_subdirectorys[3]]: {
				leer: true,
				insert: true,
				edit: true,
			}
		},
	};

	const renderContent = () => {
		if ((!obj_sucursal || obj_sucursal.length === 0) && !sucursal_selected) {
			return <div>No hay sucursales disponibles</div>;
		}

		var allowedForced = null;
		if (currentBranch?.code == "none") return <div> No tienes los permisos suficientes para acceder aquí!</div>

		if (!pageAllow[currenRoll]?.[sub_direc]) {
			if (!pageAllow[currenRoll]) return (<Error404 />);

			const getAllowed = Object.keys(pageAllow[currenRoll]);

			allowedForced = getAllowed[getAllowed.length - 1];
			navigate(`/administrar/cliente/${allowedForced}/${nit}`, { replace: true });
		}

		switch (allowedForced ?? sub_direc) {
			case "listar":
				return <Clientes
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[0]]}
					loadImageS={loadImageS}
				/>;
			case "mayorista":
				return (
					<ClientesMayoristas
						selectedSucursal={sucursal_selected}
						permisos={pageAllow[currenRoll]?.[array_subdirectorys[1]]}
						myRoll={currenRoll}
						loadImageS={loadImageS}
					/>
				);
			case "solicitudes":
				return <SolicitudesClientes
					selectedSucursal={sucursal_selected}
					permisos={pageAllow[currenRoll]?.[array_subdirectorys[2]]}
					myRoll={currenRoll}
					loadImageS={loadImageS}
				/>;
			case "usuarios":
				return (
					<Users
						selectedSucursal={sucursal_selected}
						permisos={pageAllow[currenRoll]?.[array_subdirectorys[3]]}
						myRoll={currenRoll}
						loadImageS={loadImageS}
					/>
				);
			default:
				return <div>Selecciona una sección</div>;
		}
	};

	const style_modificar = {
		alignItems: 'center',
		border: 'none',
		display: 'flex',
		flexDirection: 'row',
		gap: '15px',
		height: '60px',
		width: '100%',
	};

	const list_components = {
		[array_subdirectorys[0]]: {
			img: clientes_circular,
			text: 'Clientes'
		},
		[array_subdirectorys[1]]: {
			img: clientes_hosming,
			text: 'Mayoristas'
		},
		[array_subdirectorys[2]]: {
			img: check_paper,
			text: 'Solicitudes'
		},
		[array_subdirectorys[3]]: {
			img: usuarios,
			text: 'Trabajadores'
		}
	}

	const LogoList = (color, posicion, type) => {
		const arrayList = {
			[array_subdirectorys[0]]: {
				icon: <CirclePeopleIcon main_css={{ width: '42px' }} color={color} />,
				text: 'Clientes',
			},
			[array_subdirectorys[1]]: {
				icon: <HandsPeopleIcon main_css={{ width: '42px' }} color={color} />,
				text: 'Mayoristas',
			},
			[array_subdirectorys[2]]: {
				icon: <HojaCheckIcon main_css={{ width: '42px' }} color={color} />,
				text: 'Solicitudes',
			},
			[array_subdirectorys[3]]: {
				icon: <GroupsIcon style={{ fontSize: '42px', color: color }} />,
				text: 'Trabajadores',
			},
		};

		return arrayList[posicion]?.[type];
	}

	return (
		<div className="contenedor-bodys-products">
			{/* Menú lateral */}
			<div className="option-left option-company-left">
				<div className="accion-icons">
					{
						array_subdirectorys.map((valor) => pageAllow[currenRoll]?.[valor] && (
							<NavLink
								className={({ isActive }) => ` ${isActive ? "active-product" : ""}`}
								to={`/administrar/cliente/${valor}/${nit}`}
								style={{
									...style_modificar,
									backgroundColor: (sub_direc === valor ? 'rgba(0,0,0,0.1)' : 'transparent')
								}}
							>
								<img src={list_components[valor]?.img} style={{ width: 'var(--size-icons-global-company)' }} alt="clientes" />
								<span className="normal-black text-bold ">{list_components[valor]?.text}</span>
							</NavLink>
						))
					}
				</div>
			</div>

			<div className="floating-menu">
				<button className="default-buttons">
					<MenuIcon sx={{ color: 'var(--theme-company)', fontSize: '50px' }} />
				</button>
				<ul	>
					<div style={{ position: 'absolute', top: '0px', left: '0px', height: '100%', width: '100%', backgroundColor: 'var(--theme-company)', zIndex: 0, opacity: .15, filter: 'blur(15px)' }}></div>
					{
						array_subdirectorys.map((valor, index) => (
							pageAllow[currenRoll]?.[array_subdirectorys[index]] && (
								<li style={{ backgroundColor: (array_subdirectorys[index] == sub_direc ? 'rgba(0,0,0,0.15)' : 'transparent'), zIndex: 2 }}>
									<NavLink
										className={({ isActive }) => ` ${isActive ? "active-product" : ""}`}
										to={`/administrar/cliente/${valor}/${nit}`}
										style={style_modificar}
									>
										<Box sx={{ marginLeft: '10px' }}>
											{LogoList('var(--theme-main)', valor, 'icon')}
										</Box>

										<span style={{ color: 'var(--theme-main)', fontWeight: '500' }}>{LogoList('var(--theme-main)', valor, 'text')}</span>
									</NavLink>
								</li>
							)
						))
					}
				</ul>
			</div>

			<div className="option-right option-company-right">{renderContent()}</div>
		</div>
	);
};
